var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseWorkflowActivityAssignmentViewModel } from "../base-workflow-activity-assignment";
import { autoinject } from "aurelia-framework";
import { WorkflowAssignmentsService } from "../../../../services/workflow/workflow-assignments-service";
import { UserClientService } from "../../../../services/authentication/user-client.service";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { I18N } from "aurelia-i18n";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { DialogServiceConstants } from "../../../../../../ClientApp/app/constants/basics/dialog.constants";
var ActivityAssignment = /** @class */ (function (_super) {
    __extends(ActivityAssignment, _super);
    function ActivityAssignment(userClientService, dialogClientService, i18N, workflowAssignmentsService, notificationClientService) {
        var _this = _super.call(this, dialogClientService, i18N, workflowAssignmentsService) || this;
        _this.userClientService = userClientService;
        _this.notificationClientService = notificationClientService;
        _this.user = _this.userClientService.currentUser;
        return _this;
    }
    ActivityAssignment.prototype.submit = function () {
        return this.accept();
    };
    ActivityAssignment.prototype.accept = function () {
        var _this = this;
        require("../../../../../../ClientApp/app/views/app/admin/dialogs/confirmation-dialog");
        var confirmModel = {
            headerTitle: "confirmation-title",
            headerMessage: "confirmation-accept-text",
            btnOkayText: "confirm-text",
            btnNoText: "cancel-text",
        };
        this.dialogClientService.show(DialogServiceConstants.URLs.ConfirmationDialog, {
            confirmModel: confirmModel,
            save: function () { return new Promise(function (resolve, reject) {
                _this.workflowAssignmentsService
                    .executeAction(_this.assignment.workflowStateId, 'platform-admin-activity', 'accept', _this.assignment.workflowAssignmentId, null, _this.assignment.remarks, _this.assignment.meta)
                    .then(function (response) {
                    _this.dialogClientService.hide();
                    _this.notificationClientService.show(_this.i18N.tr("success"), _this.i18N.tr("workflow-accepted-text"), NotificationType.Success);
                    _this.reload(response.workflowState);
                    resolve();
                })
                    .catch(function () {
                    _this.dialogClientService.hide();
                    _this.notificationClientService.show(_this.i18N.tr("error"), _this.i18N.tr("generic-error-text"), NotificationType.Error);
                    reject();
                });
            }); }
        }, undefined, undefined, undefined, undefined, false);
    };
    ActivityAssignment.prototype.reject = function () {
        this.cancelWorkflow();
    };
    ActivityAssignment = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [UserClientService,
            DialogClientService,
            I18N,
            WorkflowAssignmentsService,
            NotificationClientService])
    ], ActivityAssignment);
    return ActivityAssignment;
}(BaseWorkflowActivityAssignmentViewModel));
export { ActivityAssignment };
